
import React from 'react';
import { useEffect, useState, useRef } from 'react';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useAuth from '../hooks/useAuth';
import extensionsJson from '../assets/extensions-sk.json'
import {
    MDBCol,
    MDBRow,
    MDBSwitch,
    MDBInput,
} from 'mdb-react-ui-kit';


function Extensions(props) {
    const [extensions, setExtensions] = useState();
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth
    const imgDomain = (process.env.REACT_APP_ENV === "dev") ? "https://testapi.bramac.cz/prilohy/cenovanabidka/extensions/" : "../prilohy/cenovanabidka/extensions/";
    const INIT_VALUES = {}
    const [values, setvalues] = useState(INIT_VALUES);
    const didMount = useRef(false);

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const getExtensions = async () => {
            try {
                const response = await axiosPrivate.get('/rozsireni/get?org=F001', {
                    signal: controller.signal
                });
                // console.log(response.data);
                isMounted && setExtensions(response.data);
            } catch (err) {
                //console.error(err);
            }
        }

        if (auth?.accessToken !== undefined) {
            getExtensions();
        } else {
            setExtensions(extensionsJson);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [auth])

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            props.step.data = { values }
            return;
        }
        props.step.data = { values }
    }, [values])

    async function setStep5Value(item, value) {
        if (!isNaN(value) && value < 0) {
            await setvalues({ ...values, [item]: "" });
        } else if (isNaN(value)) {
            await setvalues({ ...values, [item]: "" });
        } else {
            await setvalues({ ...values, [item]: Number(value) });
        }
    }

    extensions?.sort((a, b) => a.poradi - b.poradi);

    return (
        <div>
            {extensions?.map(extension => {
                let item = "item" + extension.id;
                const input = (extension.typ == "A/N") ? (
                    <MDBCol>
                        <MDBSwitch id={'step5' + item} label='Pridať' onChange={() => setStep5Value(item, !values[item])} />
                    </MDBCol>
                ) : (
                    <MDBCol className='col-md-3 col-lg-2'>
                        <MDBInput id={'step5' + item} label='Zadajte počet' value={values[item]} type='text' placeholder="0" pattern="[0-9]*" maxLength='3'
                            onChange={(e) => setStep5Value(item, e.target.value)} />
                    </MDBCol>
                )
                return (
                    <MDBRow className='align-items-center' key={'ext' + extension.id}>
                        <MDBCol size="8">
                            <a href={extension.url1} target='_blank' >
                                <MDBRow className='align-items-center'>
                                    <MDBCol size="4" className='col-md-3'>
                                        <img
                                            src={imgDomain + extension.obr1}
                                            className="img-fluid rounded-circle"
                                            alt="" width='100'
                                        />
                                    </MDBCol>
                                    <MDBCol>
                                        <p className='text-decoration-none content-link' dangerouslySetInnerHTML={{ __html: extension.nazevB1 }}>
                                            {/* {extension.nazevB1} */}
                                        </p>
                                    </MDBCol>
                                </MDBRow>
                            </a>
                        </MDBCol>
                        {input}
                    </MDBRow>
                )
            })}
        </div>
    );

}

export default Extensions;